
<template>

  <div class="trend-load">
    <div v-for="(b, x) in genLets()" class="trend-bar" :style="{'animation-delay': `${.5 * x}s`}"></div>
    <div class="letter-spread">
      <h2 class="genned-letter" v-for="(letter, x) in genLets()" :style="{'animation-delay': `${.5 * x}s`, 'color': 'lightgray'}">{{letter}}</h2>
    </div>
  </div>

</template>

<script>

  export default {
    data(){
      return {

      }
    },
    methods: {
      genLets(){
        return 'breezi-pro'.split('');
      }
    }
  }

</script>

<style>

.trend-load {
  width: 85%;
  height: 85%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  position: relative;
}

.trend-bar {
  width: 3%;
  height: 25px;
  background-color: rgb(0, 153, 191);
  margin: 0 5px 0 5px;
  animation: bouncetrend 3s linear;
}

@keyframes bouncetrend {
  0% {
    height: 25px;
  }
  45% {
    background-color: rgb(0, 153, 191);
  }
  50% {
    height: 225px;
    background-color: lightblue;
  }
  55% {
    background-color: rgb(0, 153, 191);
  }
  100% {
    height: 25px;
  }
}

.letter-spread {
  width: 100%;
  height: 50px;
  position: absolute;
  bottom: calc(0% + 250px);
  display: flex;
  justify-content: center;
  align-items: center;
}

.genned-letter {
  width: 3%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: lightgray;
  opacity: 0;
  animation: pulseblue 3s linear;
  margin: 0 5px 0 5px;
}

@keyframes pulseblue {
  0% {
    color: lightgray;
    opacity: 0;
  }
  25% {
    color: rgb(0, 153, 191);
    opacity: 0;
  }
  50% {
    color: lightblue;
    opacity: 1;
  }
  75% {
    color: rgb(0, 153, 191);
    opacity: 0;
  }
  100% {
    color: lightgray;
    opacity: 0;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/room/TrendLoad.vue